import React, { useState } from "react";

import UnsubscribeModal from "../components/UnsubscribeModal";
import { PACKS } from "../components/Form";
import PublicLayout from "../components/site/PublicLayout";
import SignupCard from "../components/site/SignupCard";
import VideoBackground from "../components/site/VideoBackground";
import { useSignup } from "../hooks/useSignup";

const NewHome = () => {
  const signup = useSignup();
  const [showUnsubscribeModal, setShowUnsubscribeModal] = useState(false);

  return (
    <PublicLayout background={<VideoBackground />}>
      {showUnsubscribeModal ? (
        <UnsubscribeModal
          open={showUnsubscribeModal}
          handleClose={() => setShowUnsubscribeModal(false)}
        />
      ) : null}

      <div className="mx-auto grid max-w-6xl grid-cols-1 gap-6 px-4 pb-10 pt-2 sm:px-6 lg:grid-cols-[1.1fr_1fr] lg:items-center lg:gap-x-14 lg:pt-10">
        <div>
          <h1 className="text-2xl font-extrabold leading-tight tracking-tight sm:text-4xl lg:text-5xl">
            Devenez membre du Club Sutton Encore, profitez des avantages et
            appuyez votre salle!
          </h1>
          <span className="mt-4 inline-block rounded-full bg-yellow-600 px-4 py-1.5 text-sm font-bold text-gray-900">
            {PACKS[0].label}
          </span>
        </div>

        <SignupCard {...signup} />
      </div>

      <div className="mx-auto flex max-w-6xl flex-col items-center gap-3 px-4 pb-8 text-sm text-gray-300 sm:px-6">
        <button
          type="button"
          className="hover:text-white"
          onClick={() => setShowUnsubscribeModal(true)}
        >
          Souhaitez-vous vous{" "}
          <span className="font-semibold underline">désabonner</span>?
        </button>
        <p>Ce site a été offert à Sutton Encore, gracieuseté de Bagels Round Top</p>
      </div>
    </PublicLayout>
  );
};

export default NewHome;
